import React from "react";
import "./CustomerDataSourceDefItem.scss";
import {
  Collapse,
  Table,
  TableCell,
  tableCellTypesEnum,
} from "@SeemplicityDev/shared";
import DataSourceDefInstanceActions from "./DataSourceDefInstanceActions/DataSourceDefInstanceActions";
import { createColumnHelper } from "@tanstack/react-table";
import type { CncDatasourceNode } from "../../CustomerProvisioningApi";

export interface CustomerDataSourceDefItemProps {
  accountUuid: string;
  accountName: string;
  DSType: string;
  instances: CncDatasourceNode[];
}

const CustomerDataSourceDefItem: React.FC<CustomerDataSourceDefItemProps> = ({
  accountUuid,
  accountName,
  DSType,
  instances,
}) => {
  const columnHelper = createColumnHelper<CncDatasourceNode>();

  const columns = [
    columnHelper.accessor("friendly_name", {
      id: "instanceName",
      header: "Instance Name",
      cell: (value) => <TableCell>{value.getValue()}</TableCell>,
    }),
    columnHelper.display({
      id: "actions",
      header: "",
      maxSize: 40,
      minSize: 40,
      cell: (value) => {
        const id = value.row?.original?.id;
        return (
          <TableCell type={tableCellTypesEnum.COMPONENT}>
            <DataSourceDefInstanceActions
              accountUuid={accountUuid}
              accountName={accountName}
              dsInstanceID={id}
              dsInstanceName={value.row.original.friendly_name}
              enableCheckConnection={
                value.row?.original?.datasource_definition
                  ?.enable_check_connection
              }
            ></DataSourceDefInstanceActions>
          </TableCell>
        );
      },
    }),
  ];

  return (
    <div className={"ds-instances-container"}>
      <Collapse hasTitleBorder initialState={false} label={DSType}>
        <Table
          noBorder
          columns={columns}
          data={instances}
          initialSortBy={[{ id: "instanceName", desc: false }]}
        />
      </Collapse>
    </div>
  );
};
export default CustomerDataSourceDefItem;
